import HelloWorld from "./HelloWorld";

export default HelloWorld;
